import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import {
  Container,
  ContainerFluid,
  Htag,
  HtagAlign,
  HtagVariant,
  Paragraph,
} from '../../components';
import styles from './lets-link-design.module.css';

import bg from '../../public/letslink/design/bg.jpg';
import image1 from '../../public/letslink/design/image1.png';
import image2 from '../../public/letslink/design/image2.png';
import image3 from '../../public/letslink/design/image3.png';
import image4 from '../../public/letslink/design/image4.png';
import image5 from '../../public/letslink/design/image5.png';
import image6 from '../../public/letslink/design/image6.png';
import image7 from '../../public/letslink/design/image7.png';
import image8 from '../../public/letslink/design/image8.png';

export interface LetsLinkDesignProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkDesign({
  className,
  ...props
}: LetsLinkDesignProps) {
  return (
    <section className={cn(className, styles.design)} {...props}>
      <Container variant="container_small">
        <AnimationOnScroll
          delay={0}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Htag
            tag="h2"
            align={HtagAlign.center}
            variant={HtagVariant.h2}
            className={styles.design_title}
          >
            visual design
          </Htag>
        </AnimationOnScroll>
        <AnimationOnScroll
          delay={500}
          offset={200}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInDown"
        >
          <Paragraph className={styles.design_text}>
            Since LinkApp main idea is to connect like-minded people based on
            their interests, we chose green as a main color of the app design.
            Green is about energy, fresh ideas, willingness to open new things.
            The overall aesthetics are minimalistic and clean. It keeps users
            focused on the core features of the app.
          </Paragraph>
        </AnimationOnScroll>
      </Container>
      <ContainerFluid>
        <AnimationOnScroll
          delay={800}
          offset={50}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeIn"
        >
          <div className={styles.mobileBanner}>
            <div className={styles.design_banner}>
              <Image
                alt="linkapp screens"
                objectFit="contain"
                layout="fill"
                src={bg}
              />
              <div className={styles.design_flex}>
                <div className={cn(styles.design_item, styles.animate1)}>
                  <Image
                    alt="linkapp route on the map"
                    width={260}
                    height={560}
                    src={image1}
                  />
                </div>
              </div>
              <div className={cn(styles.design_flex, styles.design_start)}>
                <div className={cn(styles.design_item, styles.animate2)}>
                  <Image
                    alt="linkapp user profile screen"
                    width={260}
                    height={560}
                    src={image2}
                  />
                </div>
                <div className={cn(styles.design_item, styles.animate3)}>
                  <Image
                    alt="linkapp chat screen"
                    width={260}
                    height={560}
                    src={image3}
                  />
                </div>
              </div>
              <div className={cn(styles.design_flex, styles.design_center)}>
                <div className={cn(styles.design_item, styles.animate4)}>
                  <Image
                    alt="linkapp comment screen"
                    width={260}
                    height={560}
                    src={image4}
                  />
                </div>
                <div className={cn(styles.design_item, styles.animate5)}>
                  <Image
                    alt="linkapp nearby places screen"
                    width={260}
                    height={560}
                    src={image5}
                  />
                </div>
              </div>
              <div className={cn(styles.design_flex, styles.design_end)}>
                <div className={cn(styles.design_item, styles.animate6)}>
                  <Image
                    alt="linkapp chat info screen"
                    width={260}
                    height={560}
                    src={image7}
                  />
                </div>
                <div className={cn(styles.design_item, styles.animate7)}>
                  <Image
                    alt="linkapp friend request screen"
                    width={260}
                    height={560}
                    src={image6}
                  />
                </div>
              </div>
              <div className={styles.design_flex}>
                <div className={cn(styles.design_item, styles.animate8)}>
                  <Image
                    alt="linkapp find event screen"
                    width={260}
                    height={560}
                    src={image8}
                  />
                </div>
              </div>
            </div>
          </div>
        </AnimationOnScroll>
      </ContainerFluid>
    </section>
  );
}
